// bookingsSaga.ts

import { call, put, select,takeLatest } from "redux-saga/effects";

import { API } from "../../api";
import {
  createBookings,
  createBookingsFailure,
  createBookingsSuccess,
  getBookings,
  getBookingsFailure,
  getBookingsSuccess,
  getFilteredBookings,
  getFilteredBookingsFailure,
  getFilteredBookingsSuccess,
  removeBookings,
  removeBookingsFailure,
  removeBookingsSuccess,
  updateBookings,
  updateBookingsFailure,
  updateBookingsSuccess,
} from "../reducers/bookingsSlice";

import { errorHandler } from "./common";

function* getBookingsSaga () {
  try {
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    const response = yield call<any>(API.get, "/orders", {
      params: {
        limit: "500",
      },
      headers: {
        Authorization: `Bearer ${  token}`,
      },
    });

    yield put(getBookingsSuccess(response.data.data));
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield getBookingsSaga();
      },
      *callback () {
        yield put(getBookingsFailure(error));
      },
    });
  }
}

function* getFilteredBookingsSaga (action: any) {
  try {
    const searchParams = action.payload;
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    const response = yield call<any>(API.get, "/orders", {
      params: {
        limit: "500",
        ...searchParams,
      },
      headers: {
        Authorization: `Bearer ${  token}`,
      },
    });

    yield put(getFilteredBookingsSuccess(response.data.data));
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield getFilteredBookingsSaga(action);
      },
      *callback () {
        yield put(getFilteredBookingsFailure(error));
      },
    });
  }
}

interface createBookingsSagaProp {
  payload: {
    paymentType: string;
    masterId: string;
    userId: string;
    studioId: number;
    from: string;
    services: [
      {
        serviceId: string;
        rank: string;
      }
    ];
    onSuccess: () => void;
    onCreateSuccess?: (response: any) => void;
    onFailure: (error: any) => void;
  };
}

function* createBookingsSaga ({
  payload: {
    paymentType,
    masterId,
    userId,
    studioId,
    from,
    services,
    onSuccess,
    onFailure,
    onCreateSuccess
  },
}: createBookingsSagaProp) {
  try {
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    const response = yield call<any>(
      API.post,
      `orders/create`,
      {
        paymentType,
        masterId,
        userId,
        studioId,
        from,
        services,
      },
      {
        headers: {
          Authorization: `Bearer ${  token}`,
        },
      }
    );

    yield put(createBookingsSuccess());
    onCreateSuccess && onCreateSuccess(response.data);
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield createBookingsSaga({
          payload: {
            paymentType,
            masterId,
            userId,
            studioId,
            from,
            services,
            onSuccess,
            onFailure,
          },
        });
      },
      *callback () {
        yield put(createBookingsFailure(error));
        onFailure(error);
      },
    });
  }
}

interface updateBookingsSagaProp {
  payload: {
    bookingId: string;
    paymentType: string;
    masterId: string;
    userId: string;
    studioId: number;
    from: string;
    services: [
      {
        serviceId: string;
        rank: string;
      }
    ];
    onSuccess: () => void;
    onFailure: (error: any) => void;
  };
}

function* updateBookingsSaga ({
  payload: {
    bookingId,
    paymentType,
    masterId,
    userId,
    studioId,
    from,
    services,
    onSuccess,
    onFailure,
  },
}: updateBookingsSagaProp) {
  try {
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    yield call<any>(
      API.put,
      `orders/${bookingId}`,
      {
        paymentType,
        masterId,
        userId,
        studioId,
        from,
        services,
      },
      {
        headers: {
          Authorization: `Bearer ${  token}`,
        },
      }
    );

    yield put(updateBookingsSuccess());
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield updateBookingsSaga({
          payload: {
            bookingId,
            paymentType,
            masterId,
            userId,
            studioId,
            from,
            services,
            onSuccess,
            onFailure,
          },
        });
      },
      *callback () {
        yield put(updateBookingsFailure(error));
        onFailure(error);
      },
    });
  }
}

interface removeBookingsSagaProp {
  payload: {
    bookingId: string;
    onSuccess: () => void;
    onFailure: (error: any) => void;
  };
}

function* removeBookingsSaga ({
  payload: { bookingId, onSuccess, onFailure },
}: removeBookingsSagaProp) {
  try {
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    yield call<any>(
      API.delete,
      `/orders/${bookingId}`,
      {
        data: {
          comment: "Remove reason",
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    yield put(removeBookingsSuccess());
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield removeBookingsSaga({
          payload: { bookingId, onSuccess, onFailure },
        });
        onFailure(error);
      },
      *callback () {
        yield put(removeBookingsFailure(error));
        onFailure(error);
      },
    });
  }
}

// Watcher Saga
export function* bookingsSaga () {
  // @ts-ignore
  yield takeLatest(getBookings().type, getBookingsSaga);
  // @ts-ignore
  yield takeLatest(getFilteredBookings().type, getFilteredBookingsSaga);
  // @ts-ignore
  yield takeLatest(createBookings().type, createBookingsSaga);
  // @ts-ignore
  yield takeLatest(updateBookings().type, updateBookingsSaga);
  // @ts-ignore
  yield takeLatest(removeBookings().type, removeBookingsSaga);
}
